export interface SampleVariable {
    key: string;
    value: string;
}

export const STATUS_OPTIONS = ["draft", "active", "inactive"];

export function renderPolicyPreview(content: string, sampleVariables: SampleVariable[] = []): string {
    let output = content || "";
    sampleVariables.forEach(({ key, value }) => {
        if (!key) return;
        output = output.split(`{{${key}}}`).join(value || `{{${key}}}`);
    });
    return output;
}

export function stripHtmlPreview(html: string, maxLength = 120): string {
    const text = (html || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}
